import { render, staticRenderFns } from "./TransaksiLintasCabang.vue?vue&type=template&id=0ef22f90&"
import script from "./TransaksiLintasCabang.vue?vue&type=script&lang=js&"
export * from "./TransaksiLintasCabang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports